import React, { useEffect } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import Button from '@material-ui/core/Button';
import SvgIcon from '@material-ui/core/SvgIcon';
import Card from '@material-ui/core/Card';
import { makeStyles } from '@material-ui/core/styles';
import Term from '../../../../../src/icons/simplifiedIssue.24.svg';
import Disability from '../../../../../src/icons/disabilityInsurance.svg';
import NumberFormat from 'react-number-format';

const useStyles = makeStyles(theme => ({
    primaryText: {
        color: theme.palette.primary.main,

    }
}));

export default function Quoter(props) {

    const classes = useStyles();

    useEffect(() => {
        let newFormState = props.fullFormState;
        let noIncome = false;
        let netWorth = Number(newFormState.pages.financialInfo.liquidAssets) + Number(newFormState.pages.financialInfo.otherAssets) + Number(newFormState.pages.financialInfo.retirementAssets) - Number(newFormState.pages.financialInfo.mortgage) - Number(newFormState.pages.financialInfo.debt);

        //FINAL EXPENSE
        if (netWorth > 500000 || newFormState.pages.clientBasicInfo.clientAge < 55 || newFormState.pages.clientBasicInfo.clientAge > 85) {
            newFormState.pages.clientBasicInfo.needsFinalExpense = false;
        }

        //ESTATE PLANNING
        if (netWorth < 100000) {
            newFormState.pages.clientBasicInfo.needsEstatePlanning = false;
        }
        //DISABILITY
        if (Number(newFormState.pages.financialInfo.mainIncome) < 18000 || newFormState.pages.clientBasicInfo.clientAge < 18 || newFormState.pages.clientBasicInfo.clientAge > 61) {
            newFormState.pages.clientBasicInfo.needsDI = false;
        }

        //LTC
        if (netWorth < 75000 || newFormState.pages.clientBasicInfo.clientAge < 18 || newFormState.pages.clientBasicInfo.clientAge > 80) {
            newFormState.pages.clientBasicInfo.needsLTC = false;
        }

        // these currently are temporarily disabled and should not be recomended
        newFormState.pages.clientBasicInfo.needsFinalExpense = false;
        newFormState.pages.clientBasicInfo.needsEstatePlanning = false;

        // No Income .. then not applicable for any products
        // If has spouse then use their income as well
        if (newFormState.pages.clientBasicInfo.maritalStatus === "Married") {
            if (Number(newFormState.pages.financialInfo.mainIncome) === 0 && Number(newFormState.pages.financialInfo.spouseIncome) === 0 && Number(newFormState.pages.financialInfo.otherIncome) === 0) {
                noIncome = true;
            }
        }
        else {
            if (Number(newFormState.pages.financialInfo.mainIncome) === 0 && Number(newFormState.pages.financialInfo.otherIncome === 0)) {
                noIncome = true;
            }
        }

        if (noIncome) {
            newFormState.pages.clientBasicInfo.needsLife = false;
            newFormState.pages.clientBasicInfo.needsFinalExpense = false;
            newFormState.pages.clientBasicInfo.needsEstatePlanning = false;
            newFormState.pages.clientBasicInfo.needsDI = false;
            newFormState.pages.clientBasicInfo.needsLTC = false;
            newFormState.pages.clientBasicInfo.needsIncome = true;
        }

        // no life insurance if single
        if (newFormState.pages.clientBasicInfo.maritalStatus === "Single") {
            newFormState.pages.clientBasicInfo.needsLife = false;
        }

        //uiFaceCalcOutput calculation
        if (newFormState.pages.clientBasicInfo.needsLife === true) {
            let face = 0;

            if (Number(newFormState.pages.additionalClientInfo.lifeReplacementYears) > 0) {
                face = ((Number(newFormState.pages.financialInfo.mainIncome) + Number(newFormState.pages.financialInfo.otherIncome)) * Number(newFormState.pages.additionalClientInfo.lifeReplacementYears));
            }

            face += Number(newFormState.pages.additionalClientInfo.collegeExpense);
            face += Number(newFormState.pages.financialInfo.mortgage);
            face += Number(newFormState.pages.financialInfo.debt);
            face -= Number(newFormState.pages.financialInfo.liquidAssets);

            if (newFormState.pages.currentInsurance.hasExistingPolicy === 'yes') {
                face = face - Number(newFormState.pages.currentInsurance.existingLifePolicyCoverage);
            }

            if (face <= 0) {
                face = 0;
                newFormState.pages.clientBasicInfo.needsLife = false;
            }
            else if (face < 5000) {
                face = 5000;
            }
            else if (face > 10000000) {
                face = 10000000;
            }
            else {
                face = Number(GlobalRoundAccuracy(face, 1000));
            }

            newFormState.pages.quoter.needsCoverageAmount = face;
        }

        //Update NeedDI based on calculations output
        if (newFormState.pages.clientBasicInfo.needsDI === true) {
            var income = Math.round(Number(newFormState.pages.financialInfo.spouseIncome) / 12);
            income += Math.round(Number(newFormState.pages.financialInfo.otherIncome) / 12);
            if (newFormState.pages.currentInsurance.hasExistingDIPolicy === 'yes') {
                income += Number(newFormState.pages.currentInsurance.existingDIPolicyCoverage);
            }
            var expenses = Number(newFormState.pages.monthlyExpenses.mortgageExpense) + Number(newFormState.pages.monthlyExpenses.additionalExpense) + Number(newFormState.pages.monthlyExpenses.nonEssentialExpense);

            var result = expenses - income;

            // we want to make sure you have entered expenses prior to calculation 
            if (result <= 0) {
                result = 0;
                newFormState.pages.clientBasicInfo.needsDI = false;
            }
            else if (result < 500) {
                result = 500;
            }
            else {
                result = GlobalRoundAccuracy(Number(result), 100);
            }

            newFormState.pages.quoter.needsDisabilityCoverageAmount = result;
        }
        props.onMultiFieldChange(newFormState);
    }, [])


    const GlobalRoundAccuracy = (num, acc) => {
        return Math.round(Number(num) * (1 / Number(acc))) * acc;
    }

    const QuoteResult = (props) => {
        return (
         <React.Fragment>
            <Row className="mb-4 my-1 mx-0">
                <Col className='w-100 p-0'>
                    <Card className="quoter-cards">
                        <div className="d-flex" id={`${props.id}-info`} name={`${props.id}-info`}>
                            <Col sm={1} className='pr-0 mt-4'>
                                <SvgIcon component={props.logoLink} color='primary' className='icon-common' id={`${props.id}-icon`} name={`${props.id}-icon`}/>
                            </Col>
                            <Col sm={11} className='pl-0'>
                                <div className='mt-1 bold-text' id={`${props.id}-text`} name={`${props.id}-text`}>{props.name}</div>
                                <div className={`${classes.primaryText} blue-text`} id={`${props.id}-amount-text`} name={`${props.id}-amount-text`}><NumberFormat displayType={'text'} prefix={'$'} value={props.coverage} thousandSeparator={true} id={`${props.id}-amount`} name={`${props.id}-amount`}/> <span className='month-text' id={props.name === 'Disability Insurance' && `${props.id}-amount-per-month`} name={props.name === 'Disability Insurance' && `${props.id}-amount-per-month`}>{props.name === 'Disability Insurance' ? '/month' : ''}</span></div>
                                {props.perMonthCost && <div className='bold-text' id={`${props.id}-cost-per-month`} name={`${props.id}-cost-per-month`}>{props.perMonthCost}</div>}
                                <p className='para-one mb-2 mt-2' id={`${props.id}-long-text`} name={`${props.id}-long-text`}>{props.longText}</p>
                                {props.shortText && <p className='para-two mb-2' id={`${props.id}-short-text`} name={`${props.id}-short-text`}>{props.shortText}</p>}
                                {props.showButton && <Button variant="contained" size="medium" color="primary" onClick={() => props.redirectLink===''? props.onNext() : props.history.push(props.redirectLink)} className='mt-2 quote-btn' id={`${props.id}-cont-btn`} name={`${props.id}-cont-btn`}>
                                  Continue
                                </Button>}
                            </Col>
                        </div>
                    </Card>
                </Col>
            </Row>       
         </React.Fragment>
        )
    }

    return (
        <Container fluid className="px-0">
            <div className='mb-3 heading-text' id='insurance-needs-text' name='insurance-needs-text'>
                Insurance Needs
            </div>
            {
                props.fullFormState.pages.clientBasicInfo.needsLife === true &&
                <QuoteResult
                    name='Life Insurance'
                    id='life-insurance'
                    coverage={props.formState.needsCoverageAmount}
                    longText="In order to protect your client’s family's financial future, they need life insurance.  There are multiple options and we can guide you to the product that best meets your client's needs."
                    shortText="Recommended coverage is based on the required income replacement plus current and anticipated future liabilities minus existing life insurance."
                    showButton={true}
                    redirectLink=""
                    history={props.history}
                    logoLink={Term}
                    perMonthCost='Approx $60-$80/month'
                    onNext = {props.onNext}
                />
            }
            {
                props.fullFormState.pages.clientBasicInfo.needsDI &&
                <QuoteResult
                    name='Disability Insurance'
                    id='disability-insurance'
                    coverage={props.formState.needsDisabilityCoverageAmount}
                    shortText="Recommended coverage is based on monthly expense minus spouse’s income, other income, and existing disability insurance coverage."
                    longText="Disability insurance protects your client’s income in the event that they become disabled.  Although they may have enough savings to meet their short-term needs, they may not be able to sustain their living expenses if they are unable to work for months or years."
                    showButton={true}
                    redirectLink="/Products/Landing/disability-insurance"
                    history={props.history}
                    logoLink={Disability}
                    perMonthCost='Approx $60-$80/month'
                />
            }
            {
                props.fullFormState.pages.clientBasicInfo.needsFinalExpense === true &&
                <QuoteResult
                    name='Final Expenses'
                    id='final-expenses'
                    longText="Today, the average funeral costs between $7,000 and $10,000. This includes the services at the funeral home, burial in a cemetery and the a simple headstone.  To avoid the burden on your family, you can purchase an inexpensive final expense policy that can help cover these costs when you pass away."
                    showButton={true}
                />
            }
            {
                props.fullFormState.pages.clientBasicInfo.needsLTC === true &&
                <QuoteResult
                    name='Long-Term Care'
                    id='long-term-care'
                    longText="Over 70 percent of Americans over the age of 65 will need long-term care services at some point. Long-term care insurance helps pay for personal care if your client is unable to care for themselves."
                    showButton={true}
                    redirectLink="/Products/Landing/ABLTC"
                    history={props.history}
                    logoLink={Term}
                />
            }
            {
                props.fullFormState.pages.clientBasicInfo.needsIncome === true &&
                <QuoteResult
                    name='No income'
                    id='no-income'
                    longText="Based on your age, financial information, existing insurance, and net worth, we currently do not have any specific products to advise."
                    showButton={false}
                    logoLink={Term}
                />
            }
            {
                props.fullFormState.pages.clientBasicInfo.needsLife !== true
                && props.fullFormState.pages.clientBasicInfo.needsDI !== true
                && props.fullFormState.pages.clientBasicInfo.needsFinalExpense !== true
                && props.fullFormState.pages.clientBasicInfo.needsLTC !== true
                && props.fullFormState.pages.clientBasicInfo.needsIncome !== true
                && props.fullFormState.pages.clientBasicInfo.needsEstatePlanning !== true &&
                <QuoteResult
                    name='You Are In Good Shape'
                    id='good-shape'
                    longText="Based on your age, financial information, existing insurance, and net worth, we currently do not have any specific products to advise."
                    showButton={false}
                    logoLink={Term}
                />

            }
            <Row className="pt-4">
                <Col className="text-left button-back">
                    <Button variant="outlined" size="medium" color="primary" onClick={props.onBack} id='quoter-back-btn' name='quoter-back-btn'>BACK</Button>
                </Col>
            </Row>
        </Container>
    )
}



Quoter.DefaultFormState = () => {
    return {
        needsCoverageAmount: 0,
        needsDisabilityCoverageAmount: 0,
    };
};



// WEBPACK FOOTER //
// ./src/components/InsuranceTools/NeedsAnalysis/steps/Quoter.js